import type { FC } from 'react'

import { Hero, Commitment, Services, /* AboutUs, */ Activity } from 'components'

import styles from './Home.module.scss'

const Home: FC = () => (
  <div className={styles.home}>
    <Hero />
    <Services />
    <Commitment />
    {/*<AboutUs />*/}
    <Activity />
  </div>
)

export default Home